import { render } from "./SettingsView.vue?vue&type=template&id=b839f202&scoped=true"
import script from "./SettingsView.vue?vue&type=script&lang=ts"
export * from "./SettingsView.vue?vue&type=script&lang=ts"

import "./SettingsView.vue?vue&type=style&index=0&id=b839f202&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b839f202"

export default script